import BankIcon from "@mui/icons-material/AccountBalanceOutlined";
import GroupIcon from "@mui/icons-material/GroupOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import { MenuList, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useMatch } from "react-router";
import useClientContext from "../../../contexts/useClientContext";
import { pageRoutes } from "../../../routes";
import { UserActions } from "../../../store/state/user/actions";
import { investorsWithSettingsAccessSelector, workspaceInvestorSelector } from "../../../store/state/user/selectors";
import InvestorsMenuSelect from "./InvestorsMenuSelect";
import MenuPageItem from "./MenuPageItem";
import SettingsMenuSection from "./SettingsMenuSection";

const SettingsMenu = () => {
  const dispatch = useDispatch();
  const { isAnyFeatureEnabled } = useClientContext();

  const routeMatch = useMatch(`/:client/${pageRoutes.settings}/lp/:page`);
  const page = routeMatch?.params.page;

  const investors = useSelector(investorsWithSettingsAccessSelector);
  const workspaceInvestor = useSelector(workspaceInvestorSelector);

  const handleInvestorSelected = (investorId: string) => dispatch(UserActions.UpdateWorkspace(investorId));

  return (
    <Stack spacing={2.5} sx={{ p: 2, width: "100%" }}>
      {workspaceInvestor &&
        isAnyFeatureEnabled(["AccountSettingsViewer", "BankAccountsDetailsViewer", "Membership"]) && (
          <>
            <InvestorsMenuSelect
              selectedId={workspaceInvestor.investorId}
              investors={investors}
              onChange={handleInvestorSelected}
            />

            <SettingsMenuSection title="Investor settings">
              <MenuList>
                <MenuPageItem
                  title="Investor Details"
                  Icon={SettingsIcon}
                  pageName="account"
                  currentPage={page}
                  requiredFeature="AccountSettingsViewer"
                />
                <MenuPageItem
                  title="Bank Accounts"
                  Icon={BankIcon}
                  pageName="bank"
                  currentPage={page}
                  requiredFeature="BankAccountsDetailsViewer"
                />
                <MenuPageItem
                  title="Contacts"
                  Icon={GroupIcon}
                  pageName="members"
                  currentPage={page}
                  requiredFeature="Membership"
                />
              </MenuList>
            </SettingsMenuSection>
          </>
        )}
    </Stack>
  );
};

export default SettingsMenu;
